<div class="p-grid">
    <div class="p-col-12 page-header">Search</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12 button-header">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2" *ngIf="canAddMember">
                <p-button label="Add Member" styleClass="fullwidthbtn" routerLink="/member/new"></p-button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2" *ngIf="canAddUser">
                <p-button label="Add User" styleClass="fullwidthbtn" routerLink="/user/invite"></p-button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2">
                <p-button label="Advanced Search" styleClass="fullwidthbtn" (click)="onClickAdvanceSearch()"></p-button>
            </div>
        </div>
    </div>
    <div class="p-col-12 card">
        <div class="p-grid">          
            <div class="p-col-12 p-lg-4 p-md-4">
                <p-dropdown [options]="filterType" [(ngModel)]="filterBy" placeholder="Filter By" optionLabel="type" [showClear]="true" optionValue="value"
                            (onChange)="FilterLists()" appendTo="body" styleClass="ui-column-filter" dataKey="value"></p-dropdown>
            </div>            
        </div>
        <p-tabView [(activeIndex)]="selectedOfficeMemberSearch">
            <p-tabPanel header="Member Firms">
                <div class="p-grid">
                    <div class="p-col-12 error-notify-text" *ngIf="searchDialogMemberMessage.length>0">
                        {{searchDialogMemberMessage}}
                    </div>
                    <div class="p-col-12" *ngIf="searchMemberDisplayList.length>0">
                        <p-dataView #dvmember
                                    [value]="searchMemberDisplayList"
                                    [paginator]="true"
                                    filterBy="IsFavorite"
                                    [rows]="rowsPerPage"
                                    [showCurrentPageReport]="true"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    [lazy]="true"
                                    (onLazyLoad)="lazyLoadMembers($event)"
                                    [totalRecords]="totalMembers"
                                    responsiveLayout="scroll">
                            <ng-template let-rowData pTemplate="listItem">
                                <div class="p-col-12">
                                    <div class="item-list">
                                        <div class="p-grid">
                                            <div class="p-col-12 p-lg-2 p-md-2">
                                                <img [src]="'data:image/png;base64,' + rowData.Icon" style="max-height: 75px; max-width: 75px;">
                                            </div>
                                            <div class="p-col-12 p-lg-6 p-md-5">
                                                <div class=""><b>{{rowData.Name}}</b> <b><span *ngIf="rowData.IsHQ">{{" - HQ"}}</span></b></div> 
                                                <div class=""> <span *ngIf="rowData.City">{{rowData.City}}</span> <span *ngIf="rowData.StatesName">{{"," + rowData.StatesName}}</span></div>
                                                <div *ngIf="rowData.OfficeEmail" class=""><b>Email: </b>{{rowData.OfficeEmail}}</div>
                                                <div *ngIf="rowData.OfficePhone" class=""><b>Phone: </b>{{rowData.OfficePhone}}</div>
                                                <div *ngIf="rowData.ExclusivityArea" class="" style="overflow-wrap: break-word;"><b>Exclusivity Area: </b>{{rowData.ExclusivityArea}}</div>
                                                <div *ngIf="rowData.Active==false"><span [class]="'object-badge status-red'">TERMINATED</span></div>
                                            </div>
                                          
                                            <div class="p-col-12 p-lg-2 p-md-2">
                                                <i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                                                    [ngStyle]="{'color': (rowData.IsFavorite) ? '#D99F00' : '#E1E3E3'}" (click)="UpdateMemberFavorite(rowData)">
                                                </i>
                                            </div>
                                            <div class="p-col-12 p-lg-2 p-md-3">
                                                <p-button label="View Details" (click)="navToMemberProfile(rowData.Id)"></p-button>
                                            </div>
                                          
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dataView>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Professionals">
                <div class="p-grid">
                    <div class="p-col-12 error-notify-text" *ngIf="searchDialogUserMessage.length>0">
                        {{searchDialogUserMessage}}
                    </div>
                    <div class="p-col-12" *ngIf="searchBrokerDisplayList.length>0">
                        <p-dataView #dvbroker
                                    [value]="searchBrokerDisplayList"
                                    [paginator]="true"
                                    filterBy="IsFavorite"
                                    [rows]="rowsPerPage"
                                    [showCurrentPageReport]="true"
                                    [rowsPerPageOptions]="rowsPerPageOptions"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    [lazy]="true"
                                    (onLazyLoad)="lazyLoadBrokers($event)"
                                    [totalRecords]="totalBrokers">
                            <ng-template let-broker pTemplate="listItem">
                                <div class="p-col-12">
                                    <div class="item-list">
                                        <div class="p-grid">
                                            <div class="p-col-12 p-lg-2 p-md-2">
                                                <img [src]="'data:image/png;base64,' + broker.ProfilePicture" style="max-height: 75px; max-width: 75px;" />
                                            </div>
                                            <div class="p-col-12 p-lg-6 p-md-5">                                               
                                                <div class="">{{getBrokerName(broker)}}</div>
                                                <div class=""><b>{{broker.DefaultMemberName}}</b></div>
                                                <div class=""><b>{{broker.DefaultMemberAddress}}</b></div>
                                                <div class=""><b>Email: </b>{{broker.Email}}</div>
                                                <div class=""><b>Phone: </b>{{broker.DirectPhone }} <span *ngIf="broker.DirectPhoneExtn"> <b> Extn:</b>{{broker.DirectPhoneExtn}}</span> </div>
                                                <div *ngIf="broker.PrimarySpecialty" class="" style="overflow-wrap: break-word;"><b>Primary Specialty: </b>{{broker.PrimarySpecialty}}</div>
                                                <div *ngIf="broker.Active==false"><span [class]="'object-badge status-red'">Inactive</span></div>
                                            </div>
                                            <div class="p-col-12 p-lg-2 p-md-2">
                                                <i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                                                    [ngStyle]="{'color': (broker.IsFavorite) ? '#D99F00' : '#E1E3E3'}" (click)="UpdateBrokerFavorite(broker)">
                                                </i>
                                            </div>
                                            <div class="p-col-12 p-lg-2 p-md-3">
                                                <p-button label="View Details" (click)="navToBrokerProfile(broker)"></p-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dataView>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>            
    </div>

</div>

<p-dialog [breakpoints]="{'960px': '100vw'}"
          styleClass="dialog-medium"
          draggable="false" modal="true"
          [closable]="true"
          header="Advanced Search"
          [(visible)]="AdvanceSearchDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="AdvanceSearchDialogMessage.length>0">
            {{AdvanceSearchDialogMessage}}
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="advanceSearchName"
                       name="advanceSearchName" />
                <label for="float-input">Firm or Professional's Name</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <p-dropdown filter=true
                            inputId="dropdown"
                            [autoDisplayFirst]="false"
                            [options]="countryOptions"
                            [(ngModel)]="advanceSearchCountryId"
                            name="advanceSearchCountryId"
                            appendTo="body"
                            (onChange)="onChangeCountry()">
                </p-dropdown>
                <label for="dropdown">Country</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <p-dropdown inputId="dropdown"
                            filter=true
                            [autoDisplayFirst]="false"
                            [options]="regionOptions"
                            [(ngModel)]="advanceSearchRegionId"
                            name="advanceSearchRegionId"
                            appendTo="body"
                            (onChange)="onChangeRegion()">
                </p-dropdown>
                <label for="dropdown">Region</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <p-dropdown inputId="dropdown"
                            filter=true
                            [autoDisplayFirst]="false"
                            [options]="stateOptions"
                            [(ngModel)]="advanceSearchStateId"
                            name="advanceSearchStateId"
                            appendTo="body">
                </p-dropdown>
                <label for="dropdown">State</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="advanceSearchCity"
                       name="advanceSearchCity" />
                <label for="float-input">City</label>
            </span>
        </div>
        <div class="p-col-12">
            <p-message severity="info" text="When searching for a city, the Country and State must also be selected" styleClass="mr-2"></p-message>
        </div>
        <div class="p-col-12" *ngIf="canSearchInactive">
            <div class="p-field-checkbox">
                <p-checkbox [(ngModel)]="IncludeInactive"
                            binary="true"
                            inputId="binary"
                            name="IncludeInactive"
                            label="Include Inactive"
                            >
                </p-checkbox>
            </div>
        </div>        
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" pTooltip="Search base on Name, Country, State and City" label="Search Professionals" (click)="advanceSearchProfessional()"></button>        
    </ng-template>
</p-dialog>
